export default __webpack_public_path__ + "static/media/logo.4ab11c35.png";